module.exports = require("react-dom");


/*****************
 ** WEBPACK FOOTER
 ** external "react-dom"
 ** module id = 34
 ** module chunks = 0
 **/